import { combineReducers, configureStore } from "@reduxjs/toolkit"
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistReducer,
  persistStore,
} from "redux-persist"
import storage from "redux-persist/lib/storage"
import globalReducer from "./global/globalReducer"

import { logedInUser, verifyToken } from "./networking/auth/services"

import {
  categorySpecificArticlesSlice,
  getArticleSlice,
  platformCategoriesSlice,
  platformListSlice,
  searchArticlesSlice,
  trendingArticlesSlice,
} from "./networking/dashboard/services"
import { getTicketListSlice } from "./networking/dashboard/tickets/services"

export const persistConfig = {
  key: "root",
  storage,
  whitelist: ["global"],
}

const rootReducer = combineReducers({
  logedInUser: logedInUser.reducer,
  verifyToken: verifyToken.reducer,
  global: globalReducer,
  trendingArticlesSlice: trendingArticlesSlice.reducer,
  platformListSlice: platformListSlice.reducer,
  searchArticlesSlice: searchArticlesSlice.reducer,
  platformCategoriesSlice: platformCategoriesSlice?.reducer,
  categorySpecificArticlesSlice: categorySpecificArticlesSlice?.reducer,
  getArticleSlice: getArticleSlice?.reducer,
  getTicketListSlice: getTicketListSlice.reducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)
export type AppDispatch = typeof store.dispatch
export default store
